<template>
  <motlet :options="motletOptions">
    <template #content>
      <v-row class="h-100">
        <v-col col="6">
          <v-card class="card-wrap">
            <v-card-title>{{ $t('ov.sys.title.ext.mem') }}</v-card-title>
            <v-card-text class="chart-area">
              <!-- eslint-disable-next-line prettier/prettier -->
              <extended-memory
                :system="system"
                :items="instances"
                :values="extendedMemory"
                :formatter="formatter.extendedMemory"
                :max="100"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col col="6">
          <v-card class="card-wrap">
            <!-- <v-card-title>{{ $t('ov.sys.title.run.workprcs') }}</v-card-title> -->
            <v-card-title>{{ $t('ov.sys.title.heap.mem') }}</v-card-title>
            <v-card-text class="chart-area">
              <!-- 2025.09.24. Heap Memory로 바꿈. -->
              <!-- <running-work-process
                :system="system"
                :items="instances"
                :values="runningWorkProcess"
                :formatter="formatter.runningWorkProcess"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              /> -->
              <!-- eslint-disable-next-line prettier/prettier -->
              <heap-memory
                :system="system"
                :items="instances"
                :values="heapMemory"
                :formatter="formatter.heapMemory"
                :max="100"
                :selected-descendant.sync="selectedDescendant"
                :contextmenu="contextmenuChart"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import { cloneDeep } from 'lodash';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
// import RunningWorkProcess from '../chart/BarVerticalStack.vue';
import ExtendedMemory from '../chart/BarVertical.vue';
import HeapMemory from '@/views/overview/system/chart/BarVertical.vue';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    // RunningWorkProcess,
    ExtendedMemory,
    HeapMemory,
  },
  data() {
    return {
      messageSequence: 0,
      values: {
        // runningWorkProcess: {},
        extendedMemory: {},
        heapMemory: {},
      },
      // runningWorkProcess: [],
      extendedMemory: {},
      heapMemory: {},
      formatter: {
        // runningWorkProcess: params => {
        //   const sum = params.reduce((acc, item) => acc + item, 0);
        //   return `${params[0]} / ${sum}`;
        // },
        extendedMemory: param => `${param.value} %`,
        heapMemory: param => `${Math.round(param.value)} %`,
      },
      contextmenuUrl: '/views/detailview/abap/process',
      selectedDescendant: {},
    };
  },
  watch: {
    instances: {
      handler: 'changeInstancesHandler',
    },
  },
  computed: {
    motletOptions() {
      return {
        id: 'overview/system/abap/InstanceSummary',
        title: this.$t('ov.sys.title.inst.sum'),
      };
    },
  },
  methods: {
    contextmenuChart(event) {
      this.onContextmenuChart(event, this.selectedDescendant);
    },
    wsDataHandler(key, response) {
      ++this.messageSequence;

      // 인스턴스 별 초기화
      // if (key.name == 'cntWorkprcsTypeStatus') {
      //   this.values.runningWorkProcess[key.instId] = {
      //     runningCount: 0,
      //     rest: 0,
      //     totalCount: 0,
      //   };
      // } else
      if (key.name == 'rawMemory') {
        this.values.extendedMemory[key.instId] = 0.0;
      }

      response.forEach(res => {
        // if (key.name == 'cntWorkprcsTypeStatus') {
        //   this.values.runningWorkProcess[key.instId].totalCount += parseInt(res.cnt);
        //   if (res.wpIstatus == 4) this.values.runningWorkProcess[key.instId].runningCount += parseInt(res.cnt);
        // } else
        if (key.name == 'rawMemory') {
          if (res.areaName == 'EXTENDED MEMORY') this.values.extendedMemory[key.instId] = parseFloat(res.currUsedP).toFixed(2);
          if (res.areaName == 'HEAP MEMORY') this.values.heapMemory[key.instId] = parseFloat(res.currUsedP).toFixed(2);
        }
      });

      // 모든 인스턴스 값이 지정되었을 경우
      if (this.messageSequence == this.instances.length) {
        // if (key.name == 'cntWorkprcsTypeStatus') {
        //   Object.keys(this.values.runningWorkProcess).forEach(instId => {
        //     this.values.runningWorkProcess[instId].rest = this.values.runningWorkProcess[instId].totalCount - this.values.runningWorkProcess[instId].runningCount;
        //     delete this.values.runningWorkProcess[instId].totalCount;
        //   });
        //   this.runningWorkProcess = this.instances.map(instance => {
        //     return [
        //       {
        //         name: 'runningCount',
        //         value: this.values.runningWorkProcess[instance.id].runningCount,
        //         color: instance.color,
        //       },
        //       {
        //         name: '_empty',
        //         value: this.values.runningWorkProcess[instance.id].rest,
        //         color: '#6B717D',
        //       },
        //     ];
        //   });
        // }
        this.extendedMemory = cloneDeep(this.values.extendedMemory);
        this.heapMemory = cloneDeep(this.values.heapMemory);
        this.messageSequence = 0;
      }
    },
    // subscribe() {
    //   this.$websocket.realtime.subscribe({
    //     requests: this.instances.map(instance => ({
    //       key: { name: 'cntWorkprcsTypeStatus', sstmId: instance.systemId, instId: instance.id },
    //       fields: ['wpIstatus', 'cnt'],
    //       handler: {
    //         every: this.wsDataHandler,
    //       },
    //     })),
    //   });
    // },
    sendMessage() {
      this.$websocket.realtime.send({
        requests: this.instances.map(instance => ({
          key: { name: 'rawMemory', sstmId: instance.systemId, instId: instance.id },
          fields: ['areaName', 'currUsedP'],
          handler: {
            every: this.wsDataHandler,
          },
        })),
      });
    },
    initialize() {
      this.messageSequence = 0;
      // value init
      Object.keys(this.values).forEach(key => (this.values[key] = {}));
      // this.runningWorkProcess = [];
      this.extendedMemory = {};
      this.heapMemory = {};

      // websoket message init
      this.wsRequestMessages = {};
    },
    changeInstancesHandler() {
      this.initialize();
      this.sendMessage();
      // this.subscribe();
    },
  },
};
</script>

<style scoped>
.chart-area {
  height: calc(100% - 37px);
}
</style>
